import * as React from 'react';
export const IcMoonWaxing26Cresent = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.4 3.57-7.98 7.97-8C14.41 5.82 16 8.72 16 12c0 3.28-1.59 6.18-4.03 8C7.57 19.98 4 16.4 4 12z'
      fill='currentColor'
    />
  </svg>
);
